// extracted by mini-css-extract-plugin
export default {"gallery":"iconGallery_gallery__hAlFP","iconItem":"iconGallery_iconItem__ejxop"};